import { FIELD_XXS } from "../../helpers";
export var MIN_WIDTH_COMBOBOX = FIELD_XXS;
export var DEFAULT_MAX_WIDTH_COMBOBOX_TOOLTIP = '720px';
//# sourceMappingURL=helpers.js.map